import { TextMap } from "../types";

const en: TextMap = {
  choose_preferred_wallet: "Choose your preferred wallet",
  connect_mobile_wallet: "Connect to Mobile Wallet",
  scan_qrcode_with_wallet: "Scan QR code with a WalletConnect-compatible wallet",
  connect: "Connect",
  // TODO: review following translations
  qrcode: "QR Code",
  mobile: "Mobile",
  copy_to_clipboard: "Copy to clipboard",
  copied_to_clipboard: "Copied to clipboard!",
  show_more: "Show More",
  show_less: "Show Less",
};

export default en;
